// extracted by mini-css-extract-plugin
export default {"container":"styles_container__-3LsL","textWrapper":"styles_textWrapper__JRUz2","link":"styles_link__Jq0p1"};